import { call, put, takeLatest } from "redux-saga/effects";
import { httpAddKnowledge } from "../../../services/questions";
import {
  createAddKnowledgeStart,
  createAddKnowledgeStartFailure,
  createAddKnowledgeStartSuccess,
} from "../reducer";

import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* createAddKnowledge({ payload }) {
  const { data, onFailure } = payload;
  const response = yield call(httpAddKnowledge, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createAddKnowledgeStartSuccess(raw));

  } else {
    yield put(createAddKnowledgeStartFailure(message || raw));
    if (onFailure) {
        onFailure();
      }
    networkErrorHandler(response.statusCode, message || raw);
  }
}

export default function* onCreateAddknowledge() {
  yield takeLatest(createAddKnowledgeStart.type, createAddKnowledge);
}
